import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../services/language.service';

@Component({
  standalone: false,
  selector: 'app-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.css']
})
export class GenericDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  input: boolean = false;
  isUsed: boolean = false;
  message: string = '';
  isCompleteOrIncomplete: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GenericDialogComponent>,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
    this.isCompleteOrIncomplete = this.local_data.isCompleteOrIncomplete;
    this.isUsed = this.local_data.isInUse;
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });
  }

  doActionIsComplete(value: boolean) {
    //if (this.isUsed) return;

    this.input = true
    this.dialogRef.close({
      data: this.input,
      isComplete: value,
      isIncomplete: !value
    });
  }

  doAction() {
    this.input = true
    this.dialogRef.close({ data: this.input });
  }

}
